import CheckboxModal from "./checkbox";
import CheckBoxListModal from "./checkbox-list";
import DateModal from "./date";
import DocumentViewer from "./documentViewer";
import DynamicListModal from "./dynamicList";
import GridModal from "./gridModalProps";
import ImageModal from "./image";
import LinkedListModal from "./linked-list";
import Minute from "./minute";
import MultDocsUpload from "./multiDocsUpload";
import MultipleUploadRequired from "./multipleUploadRequired";
import NewDocumentUpload from "./new-document-upload";
import NumberModal from "./number";
import SelectModal from "./select";
import StepperModal from "./stepperModalProps";
import TextModal from "./text";
import TextCNPJModal from "./text-cnpj";
import TextCPFModal from "./text-cpf";
import TypographyModal from "./typograph";
import {
  STEPPER,
  GRID,
  TYPOGRAPHY,
  IMAGE,
  TEXT,
  NUMBER,
  DATE,
  CNPJ,
  CPF,
  OPTIONLIST,
  CHECKBOX,
  CHECKBOXLIST,
  LINKEDLIST,
  MINUTE,
  UPLOADDOCUMENT,
  MULTDOCSUPLOAD,
  DYNAMICLIST,
  DOCUMENTVIEWER,
  MULTIPLEUPLOADREQUIRED,
} from "../constants";

export const modalForms = {
  [TEXT]: TextModal,
  [IMAGE]: ImageModal,
  [TYPOGRAPHY]: TypographyModal,
  [NUMBER]: NumberModal,
  [DATE]: DateModal,
  [STEPPER]: StepperModal,
  [GRID]: GridModal,
  [OPTIONLIST]: SelectModal,
  [CHECKBOX]: CheckboxModal,
  [CHECKBOXLIST]: CheckBoxListModal,
  [LINKEDLIST]: LinkedListModal,
  [UPLOADDOCUMENT]: NewDocumentUpload,
  [MULTDOCSUPLOAD]: MultDocsUpload,
  [MINUTE]: Minute,
  [CNPJ]: TextCNPJModal,
  [CPF]: TextCPFModal,
  [DYNAMICLIST]: DynamicListModal,
  [DOCUMENTVIEWER]: DocumentViewer,
  [MULTIPLEUPLOADREQUIRED]: MultipleUploadRequired,
};
